import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import { IDetailingProjectState } from '../../../../../store/ducks/fabrication-purchase-order/types';
import CheckoutTableHeader from '../CheckoutTableHeader';
import { CheckoutContainer, TableContainer } from '../styles';
import { Table as HefestoTable } from '@gerdau/hefesto-mais-web';

interface FabricationCheckoutProjectsTableDataSource {
  key: number;
  projectFileName: string;
  pavement: string;
  revision: string;
  repetitionNumber: string;
  completeDraw: boolean;
  structuralDetails: string;
}

interface IExtraItensTableProps {
  goToDetailingProject(): void;
  detailingProject: IDetailingProjectState;
  isGeneratingPdf?: boolean;
}

const ProjectsTable: React.FC<IExtraItensTableProps> = ({
  detailingProject,
  goToDetailingProject,
  isGeneratingPdf = false
}) => {
  const fabricationProjectsState = useSelector(
    (appState: ApplicationState) => appState.fabricationProjects
  );

  const getDataTable = (): FabricationCheckoutProjectsTableDataSource[] => {
    const dataTable: FabricationCheckoutProjectsTableDataSource[] = [];

    const getFileName = (projectId?: number): string => {
      const file = fabricationProjectsState.projects?.find(
        (project) => project.id === projectId
      );
      return file?.fileName || ' - ';
    };

    detailingProject.itens.forEach((item, idx) => {
      dataTable.push({
        key: idx,
        projectFileName: getFileName(item.projectId),
        pavement: item.pavement,
        structuralDetails: item.observation,
        completeDraw: item.completeDrawing,
        repetitionNumber: item.amount?.toString() || '',
        revision: item.revision
      });
    });

    return dataTable;
  };

  const [fabricationProjectsData] = useState<
    FabricationCheckoutProjectsTableDataSource[]
  >(getDataTable());

  const getColumns = () => {
    const columns = [
      {
        title: 'Arquivos do projeto',
        dataIndex: 'projectFileName',
        width: '12rem',
        render: (text: string) => <span>{text}</span>
      },
      {
        title: 'Revisão',
        dataIndex: 'revision',
        render: (text: string) => <span>{text}</span>
      },
      {
        title: 'Pavimento',
        dataIndex: 'pavement',
        render: (text: string) => <span>{text}</span>
      },
      {
        title: 'Nº de repetições',
        dataIndex: 'repetitionNumber',
        render: (text: string) => <span>{text}</span>
      },
      {
        title: 'Desenho completo',
        dataIndex: 'completeDraw',
        render: (completeDraw: boolean) => (
          <span>{completeDraw ? 'Sim' : 'Não'}</span>
        )
      },
      {
        title: 'Detalhes dos elementos estruturais',
        dataIndex: 'structuralDetails',
        width: '18rem',
        render: (text: string) => <span>{text || ' - '}</span>
      }
    ];

    return columns;
  };

  return (
    <CheckoutContainer>
      {!isGeneratingPdf && (
        <CheckoutTableHeader
          title="Projetos"
          onEditClick={goToDetailingProject}
        />
      )}

      <TableContainer>
        <HefestoTable
          columns={getColumns()}
          dataSource={fabricationProjectsData}
          scroll={{
            x: 'max-content'
          }}
        />
      </TableContainer>
    </CheckoutContainer>
  );
};

export default ProjectsTable;
